import { ModalProps } from '@/types/shared'
import React from 'react'
import { Dialog } from 'vnetwork-ui'
import ShareObjectForm from './ShareObjectForm'
import { ObjectType } from '@/modules/Drive/types'

export interface ShareObjectModalProps extends ModalProps {
    objectName: string
    objectKey: string
    objectType: ObjectType
}

const ShareObjectModal: React.FC<ShareObjectModalProps> = ({
    open,
    onClose,
    objectName,
    objectKey,
    objectType,
}) => {
    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={'Tạo link chia sẻ'}
            children={
                <ShareObjectForm
                    onClose={onClose}
                    objectName={objectName}
                    objectKey={objectKey}
                    objectType={objectType}
                />
            }
            actions={null}
        />
    )
}

export default ShareObjectModal
